export default __webpack_public_path__ + "static/media/CRONA.427ecdb9.svg";